import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import LoadingWrapper from 'components/Common/LoadingWrapper';
import ModalWrapper from 'components/Modals/ModalWrapper';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';

class EditCustomerLegalEntitiesModalForm extends Component {
  static defaultProps = {
    isGettingCustomerLegalEntities: false,
    customerList: [],
    legalEntityList: [],
    clientId: null
  };

  static propTypes = {
    isGettingCustomerLegalEntities: PropTypes.bool,
    isShown: PropTypes.bool.isRequired,
    onConfirmLegalEntityIdChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    customerList: PropTypes.arrayOf(PropTypes.shape()),
    legalEntityList: PropTypes.arrayOf(PropTypes.shape()),
    clientId: PropTypes.number
  };

  constructor(props) {
    super(props);

    this.state = {
      newLegalEntity: null,
      formErrors: null
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    const {
      onConfirmLegalEntityIdChange,
      customerList
    } = this.props;
    const { newLegalEntity } = this.state;
    const newLegalEntityId = newLegalEntity ? newLegalEntity.id : 0;

    event.preventDefault();

    if (!newLegalEntity || newLegalEntityId <= 0) {
      toastr.error('', 'Please find & select a valid Legal Entity');
      return;
    }

    if (!customerList || customerList.length === 0) {
      toastr.error('', 'Please close the window and try again');
      return;
    }

    onConfirmLegalEntityIdChange(customerList, newLegalEntityId);
    this.setState({ newLegalEntity: { value: '' } });
  }

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  onLegalEntitySelectedItem = (lookupValue) => {
    this.setState({ newLegalEntity: lookupValue });
  };

  onLegalEntityChange = (e, newValue) => {
    this.setState({ newLegalEntity: null });
  };

  fieldHasErrors(field) {
    const { formErrors } = this.state;
    return formErrors != null && formErrors.filter(error => error.field === field).length > 0;
  }

  render() {
    const { isShown, onCancel, customerList, clientId, legalEntityList, isGettingCustomerLegalEntities } = this.props;
    const {
      newLegalEntity,
    } = this.state;

    function getUsTaxObligation(usTaxObligation) {
      if (!usTaxObligation && usTaxObligation !== false) {
        return 'Not set';
      }

      return usTaxObligation ? 'Yes' : 'No';
    }

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Change Legal Entities"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ onCancel }
        formId="customerLegalEntityEditForm"
        modalSize="edit-customer-legal-entities-modal"
        useDummySubmit
      >
        <div className="edit-customer-legal-entities-modal">
          <form className="form-horizontal" id="customerLegalEntityEditForm" name="customerLegalEntityEditForm" onSubmit={ this.handleSubmit }>
            { customerList && customerList.length === 1 && <div className="form-group">
              <div className="col-12">
                <p>
                  Editing Legal Entities linked to Customer <span style={ { fontWeight: 'bold' } }>{ customerList[0].customerId } - { customerList[0].name }</span>
                </p>
              </div>
            </div> }

            { customerList && customerList.length <= 1 && <div className="form-group">
              { isGettingCustomerLegalEntities && <LoadingWrapper loaded={ !isGettingCustomerLegalEntities } /> }
              { !isGettingCustomerLegalEntities && legalEntityList && <div className="col-12">
                <p>These legal entities are currently linked to this customer</p>
                <table className="table table-bordered table-vert-scroll table-striped table-hover">
                  <thead>
                    <tr>
                      <th className="col-8">Name</th>
                      <th className="col-2">Identifier</th>
                      <th className="col-2">Has US Tax Obligation</th>
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    { legalEntityList.map(item => <tr key={ item.id }>
                      <td className="col-8">{ item.name }</td>
                      <td className="col-2">{ item.identifier }</td>
                      <td className="col-2">{ getUsTaxObligation(item.usTaxObligation) }</td>
                    </tr>) }
                    { legalEntityList && legalEntityList.length <= 0 && <tr>
                      <td colSpan="3" className="col-12 text-center pad-y-1">No legal entities are linked to this customer</td>
                    </tr>}
                  </tbody>
                </table>
              </div> }
            </div> }
            <div className="form-group">
              <div className="col-12 mt-2">
                <p>
                  Please choose the Legal Entity that will replace all current Legal Entity links for the customer
                </p>
              </div>
            </div>
            <div className="form-group">
              <div className="col-4">
                <label
                  htmlFor="legal-entity-id"
                  className="form-label m-2 text-right"
                >
                  Legal Entity
                </label>
              </div>
              <div className="col-8">
                <AutoCompleteInput
                  id="legal-entity-id"
                  name="legalEntity"
                  category="legalentity"
                  context={ clientId != null ? { type: 'client', id: clientId, value: '' } : null }
                  placeholder="Enter legal entity name..."
                  className={ this.fieldHasErrors('legalEntity') ? 'is-error m-2' : 'm-2' }
                  value={ newLegalEntity || '' }
                  onSelectedItem={ lookupValue => this.onLegalEntitySelectedItem(lookupValue) }
                  onChange={ (e, newVal) => this.onLegalEntityChange(e, newVal) }
                />
              </div>
            </div>
            <button
              type="submit"
              id="dummy-add-form-btn"
              className="none"
            >Confirm
            </button>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

const EditCustomerLegalEntitiesModalReduxForm = reduxForm({
  form: 'customerLegalEntityEditForm'
})(EditCustomerLegalEntitiesModalForm);

const mapStateToProps = (state) => {
  if (state.auth && state.auth.settings) {
    if (state.forms != null && state.forms.currentForm != null && state.forms.currentForm.length > 0) {
      const customerList = state.forms.currentForm.map(item => ({ id: item.customerDbId, customerId: item.customerId, name: item.customerName }));
      const { clientId } = state.forms.currentForm[0];
      let clientIdListOk = true;
      let i = 1;
      while (clientIdListOk && i < state.forms.currentForm.length) {
        clientIdListOk = state.forms.currentForm[i].clientId === clientId;
        i += 1;
      }

      if (!clientIdListOk) {
        toastr.error('', 'The forms selected do not all belong the to same client');
        return {};
      }

      const { isGettingCustomerLegalEntities, legalEntityList } = state.forms;

      return {
        isGettingCustomerLegalEntities,
        legalEntityList,
        customerList,
        clientId
      };
    }
  }
  return {};
};

export const EditCustomerLegalEntitiesModal = connect(
  mapStateToProps
)(EditCustomerLegalEntitiesModalReduxForm);

export default EditCustomerLegalEntitiesModal;
